import { isNaN } from 'lodash'

/**
 * URL から origin 部を省いた文字列を返します
 *
 * @param {String} url URL
 * @return {String} origin 部を省いた文字列
 */
export function dropOrigin(url) {
  try {
    const { pathname, search, hash } = new URL(url)
    return `${pathname}${search}${hash}`
  } catch (e) {
    return url
  }
}

/**
 * クエリパラメータの値を boolean に変換します
 *
 * @param {*} value クエリパラメータの値
 * @return {boolean} パラメータ無し(undefined), 0, false 以外かどうか
 */
export function toBoolean(value) {
  if (value === undefined) return false
  if (value === null) return true
  if (!isNaN(+value)) return !!+value
  return value.toLowerCase() !== 'false'
}
